// Keep useful context when an island, Vue prop or console log contains a whole HTML page.
function boundedValue(value, budget, seen = new WeakSet(), depth = 0) {
    if (budget.remaining <= 0) return '[truncated]'
    if (typeof value === 'string') {
        const limit = Math.min(1000, budget.remaining)
        budget.remaining -= Math.min(value.length, limit)
        return value.length > limit ? value.slice(0, limit) + '…[truncated]' : value
    }
    budget.remaining -= 16
    if (value === null || typeof value === 'boolean' || typeof value === 'number') return value
    if (typeof value !== 'object') return boundedValue(String(value), budget, seen, depth)
    if (seen.has(value)) return '[circular]'
    if (depth >= 5) return '[truncated]'
    seen.add(value)
    const result = Array.isArray(value) ? [] : {}
    for (const key of Object.keys(value).slice(0, 20)) {
        if (budget.remaining <= 0) break
        if (['__proto__', 'constructor', 'prototype'].includes(key)) continue
        budget.remaining -= Math.min(key.length, 80)
        result[key.slice(0, 80)] = boundedValue(value[key], budget, seen, depth + 1)
    }
    seen.delete(value)
    return result
}

export function limitBreadcrumb(breadcrumb) {
    const budget = { remaining: 1500 }
    breadcrumb.message = boundedValue(breadcrumb.message, budget)
    breadcrumb.metadata = boundedValue(breadcrumb.metadata, budget)
}

export function limitEventPayload(event) {
    const metadata = event.toJSON?.().metaData
    if (metadata) {
        const budget = { remaining: 16000 }
        const sections = [...new Set(['island', 'navigation', 'sceneGrid', ...Object.keys(metadata)])]
        for (const [index, section] of sections.entries()) {
            if (!(section in metadata)) continue
            const value = index < 20 && budget.remaining > 0 ? boundedValue(metadata[section], budget) : null
            event.clearMetadata(section)
            if (value && typeof value === 'object') event.addMetadata(section.slice(0, 80), value)
        }
    }
    event.breadcrumbs?.forEach(limitBreadcrumb)
    event.errors?.forEach((error) => {
        if (typeof error.errorMessage === 'string' && error.errorMessage.length > 2000) {
            error.errorMessage = error.errorMessage.slice(0, 2000) + '…[truncated]'
        }
    })
}
